import React from 'react';

const PaymentProcess = {
  title: 'Payment Process',
  items: [
    {
      header: 'How do I pay?',
      content: (
        <div>
          <p>TakeMeTour accepts any major credit card and you can make a payment directly on our website. The payment is securely processed by a world-class system, Omise. You may also make a payment through PayPal.</p>
          <p>The transaction will be made only after you fill out your billing information and the Local Expert confirms your booking request.</p>
          <p>Please also note that in order for your trip to be confirmed, your booking must be paid for. In the meantime, you will be unable to exchange your personal contact information with the Local Expert.</p>
        </div>
      )
    },
    {
      header: 'Can I pay in cash?',
      content: (
        <div>
          <p>Due to our policy, your booking can only be confirmed once the payment is made on our website with valid payment information. We cannot issue a booking voucher for any unsuccessful booking on the website.</p>
          <p>The procedure helps Local Experts and travelers avoid dispute that may arise when paying in cash in person. Please rest assured that this amount of money will not be instantly transferred to the Local Expert. TakeMeTour will hold it and later transfer it to the Local Expert after your trip ends.</p>
        </div>
      )
    },
    {
      header: 'How can I redeem my promo code?',
      content: (
        <div>
          <p>To redeem, enter your promo code in the ‘Promo Code’ box on the checkout page. The discount will be activated before the final payment process. Please check if the amount discounted is correct before you confirm the payment.</p>
        </div>
      )
    },
    {
      header: 'What if I can’t pay?',
      content: (
        <div>
          <p>Please try one of the following:</p>
          <ul>
            <li><p>Most credit cards are accepted, but in case your card is rejected, please try again with a different card.</p></li>
            <li><p>If it still does not work, you may also complete the payment with PayPal Express, which does not require PayPal account.</p></li>
            <li><p>If you are forced to sign up for PayPal in order to complete the payment, it is beyond our control. However, we advise you to sign up for PayPal to use the service.</p></li>
          </ul>
          <p>If you still cannot complete the payment even after following the solutions, please do not hesitate to contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    },
    {
      header: 'Can I pay in another currency? / Which currencies does TakeMeTour accept?',
      content: (
        <div>
          <p>TakeMeTour displays prices in multiple currencies including USD, THB, SGD, EUR, GBP and more. You can change the currency displayed with the currency dropdown menu at the bottom of the page.</p>
        </div>
      )
    },
    {
      header: 'Do you have a physical office where we can make a purchase?',
      content: (
        <div>
          <p>Unfortunately, buying a tour, ticket, or other services at our physical office is not possible.</p>
          <p>However, we do encourage you to book through our website for more special deals and exclusive privileges for you.</p>
        </div>
      )
    },
    {
      header: 'What if the Local Expert asks for extra payment?',
      content: (
        <div>
          <p>When booking a trip with us, price condition will be shown under the itinerary and trip conditions. Please check the price condition of each trip and see what has been included and not included in the trip fee.</p>
          <p>Under the following circumstances, extra payment is required:</p>
          <ul>
            <li><p>You need to add more travelers to your booking after you complete the payment</p></li>
            <li><p>You request for other activities that aren’t listed in the itinerary</p></li>
          </ul>
          <p>If your Local Expert asks for extra payment that isn’t stated in the trip detail page or in your messages with them, please report the issue to us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    }
  ]
};

export default PaymentProcess;
